export default __webpack_public_path__ + "static/media/Balance_Sheet.1034fb63.svg";